import { forwardRef } from 'react';
import { styled } from 'goober';

export const SheetBubble = styled('div')(({ theme }) => ({
    background: theme.colors.error.w500,
    color: '#fff',
    fontSize: '9px',
    position: 'absolute',
    top: '0px',
    right: '3px',
    width: '15px',
    height: '15px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
}));

export const SheetOverlayInfo = styled('div')(() => ({
    position: 'absolute',
    bottom: '20px',
    right: '20px',
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
}));

export const SheetOverlayGroup = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',

    background: theme.colors.neutral.w100,
    color: theme.colors.ui.dark,
    border: '1px solid',
    borderColor: theme.colors.neutral.w300,
    borderRadius: '12px',
    overflow: 'hidden',
}));

export const SheetOverlayBadge = styled('div')<{ $disabled?: boolean }>(({ theme, $disabled }) => ({
    height: '24px',
    cursor: $disabled === false ? 'pointer' : undefined,
    color: $disabled ? theme.colors.neutral.w500 : undefined,
    fill: $disabled ? theme.colors.neutral.w500 : undefined,

    '&:hover': {
        background: !$disabled ? theme.colors.neutral.w300 : undefined,
    },
}));

export const SheetOverlayStat = styled(SheetOverlayBadge)(({ theme }) => ({
    cursor: 'pointer',
    padding: '4px 8px',

    span: {
        color: theme.colors.neutral.w700,
    },
}));

export const SheetPopup = styled(
    'div',
    forwardRef
)<{ $left?: number; $top?: number; $minWidth?: number }>(({ theme, $left = 0, $top = 0, $minWidth }) => ({
    position: 'absolute',
    left: `${$left}px`,
    top: `${$top}px`,
    minWidth: $minWidth ? `${$minWidth}px` : 0,
    border: `1px solid ${theme?.colors.neutral.w200}`,
    borderRadius: '6px',
    boxShadow: `0px 4px 16px ${theme.boxShadow}`,
    backgroundColor: 'white',
    padding: '8px',
    pointerEvents: 'auto',

    th: {
        textAlign: 'left',
        fontWeight: 'normal',
        color: theme.colors.neutral.w700,
        whiteSpace: 'nowrap',
    },
    td: {
        whiteSpace: 'nowrap',
    },
}));

export const SheetBreadcrumbItem = styled('div')(({ theme }) => ({
    color: theme.colors.neutral.w700,
    fontSize: '10px',
    fontWeight: 400,
    cursor: 'pointer',
    '&:hover': {
        color: theme.colors.primary.w500,
    },
}));

export const SheetBreadcrumbSeparator = styled('div')(({ theme }) => ({
    color: theme.colors.neutral.w700,
    fontSize: '10px',
    fontWeight: 400,
    padding: '0px 4px',
}));

export const GoalIndicator = styled('div')<{ $color?: 'primary' | 'warning' | 'error' }>(({ theme, $color }) => ({
    display: 'inline-block',
    padding: '2px 4px',
    borderRadius: '6px',
    fontWeight: 400,
    backgroundColor: $color ? theme.colors[$color].w50 : undefined,
    color: $color ? theme.colors[$color].w500 : undefined,
}));

export const SheetCustomInputBox = styled('div')(({ theme }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    gap: '4px',
    marginLeft: '-2px',
    marginTop: '-2px',
    marginRight: '-2px',
    backgroundColor: '#fff',
    width: 'auto',
    minWidth: '100px',
    boxShadow: `0px 4px 16px ${theme.boxShadow}`,
    padding: '0px 5px',
    border: `2px solid ${theme.colors.primary.w500}`,
}));
